export default __webpack_public_path__ + "static/media/computer-lab-3.da27bc36.jpg";